export const totalUsersHeaders = [
  { label: 'Date', key: 'date' },
  { label: 'Users', key: 'users' },
]
